module.exports = __webpack_public_path__ + "img/baloon9.2e45e460.png";